import {
  ApplicationConfig,
  provideZoneChangeDetection,
  APP_INITIALIZER,
} from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';

import { routes } from './app.routes';
import { provideHttpClient } from '@angular/common/http';
import { RedeemWindowService } from './services/redeem-window.service';

function loadRedeemState(redeem: RedeemWindowService) {
  // ต้องคืนเป็นฟังก์ชันที่ return Promise หรือ Observable
  return () => redeem.loadFromStorage();
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      withInMemoryScrolling({
        scrollPositionRestoration: 'enabled',
      })
    ),
    {
      provide: APP_INITIALIZER,
      useFactory: loadRedeemState,
      deps: [RedeemWindowService],
      multi: true,
    },
    provideHttpClient(),
  ],
};
